import Plugin from 'src/plugin-system/plugin.class';
import Swiper from 'swiper/bundle';

export default class ImageCaptionSliderPlugin extends Plugin {
    init() {

        const swiper = new Swiper('.image-caption-slider-widget', {
            slidesPerView: 3,
            spaceBetween: 10,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true,
                snapOnRelease: true
            },
            loop: false,
            centeredSlides: false
        });

        document.addEventListener('Viewport/hasChanged', () => {
            swiper.update();
        });

    }
}